import React from 'react';
import WorkInProgress from '../../Unauthorised/WorkInProgress';

const SupportTicket = () => {
  return <WorkInProgress />;
};

export default SupportTicket;